var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "87.277 1.2865 325.4461 497.4271",
    width: 325.4461,
    height: 497.4271,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525,
    height: 203,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_10)",
    transform: "matrix(2.456429958343506, 0, 0, 2.456429958343506, 87.2769546508789, 0.058251004666082906)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0818 62.636C87.6838 32.826 70.8038 6.85 62.0118 0.606999C61.9718 0.566799 61.1888 0.145297 61.2488 1.3096C61.2488 1.3296 61.2288 1.3296 61.2288 1.3497C60.3258 57.658 31.3818 72.834 15.6658 93.47C-19.2592 139.359 9.88484 191.713 47.6398 201.629C48.2828 201.79 50.0288 202.312 53.3408 202.994C55.0668 203.356 55.5688 201.89 54.3038 199.702C49.7878 191.853 41.7588 178.604 40.1738 161.581C36.5608 122.055 86.3788 97.324 87.0818 62.636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.11 81.727C105.809 81.506 105.388 81.526 105.348 81.907C104.545 89.074 97.138 103.929 87.383 117.82C54.545 164.653 71.085 185.891 83.931 200.626C86.299 203.356 87.483 202.754 88.728 200.807C89.892 198.96 91.658 196.611 99.246 193.018C100.43 192.456 129.093 177.24 132.204 142.592C135.195 109.068 113.697 87.869 106.11 81.727Z",
    fill: "#008CD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtxLogo);
export default __webpack_public_path__ + "static/media/HTXLogo.c7d38ca8b21b94a4426dff5370cab56b.svg";
export { ForwardRef as ReactComponent };